import React from 'react';
import type { RequestStatus } from '../../types/hr';
import { Badge } from '../ui/Badge';
import type { BadgeTone } from '../ui/Badge';
const MAP: Record<RequestStatus, {
  tone: BadgeTone;
  label: string;
}> = {
  pending: {
    tone: 'orange',
    label: 'Pending'
  },
  approved: {
    tone: 'green',
    label: 'Approved'
  },
  denied: {
    tone: 'red',
    label: 'Denied'
  },
  cancelled: {
    tone: 'grey',
    label: 'Cancelled'
  }
};
export function RequestStatusBadge({
  status
}: {
  status: RequestStatus;
}) {
  const {
    tone,
    label
  } = MAP[status];
  return <Badge tone={tone} dot data-id="element-815" data-mp="rwn4g825192a">
      {label}
    </Badge>;
}